import React, { useEffect, useState } from 'react';

/** Image preview for admin/player — always resolves via S3, never local /future paths. */
export default function ThemeAssetImg({ asset, alt = '', className = '', resolveUrl }) {
  const [failed, setFailed] = useState(false);
  const url = resolveUrl ? resolveUrl(asset) : asset;

  useEffect(() => {
    setFailed(false);
  }, [url]);

  if (!url || failed) {
    return (
      <div className={`theme-asset-img theme-asset-img--empty ${className}`.trim()} aria-hidden>
        No preview
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={`theme-asset-img ${className}`.trim()}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
